/** @jsx jsx */
import { h, FunctionalComponent } from 'preact'
import { jsx } from '@emotion/core'
import { Post } from '../types'
import { StylesObject } from '../../../types/styles'
import { addUtmSourceToUrl } from '../utils'

interface LinkProps {
    styles: StylesObject
    post: Post
    index: number
    onLinkClick: (url: string, index: number) => void
}

export const Link: FunctionalComponent<LinkProps> = ({ styles, post, index, onLinkClick }) => {
    return (
        <div key={post.id} css={styles.linkWrapper}>
            <div css={styles.circle}>&bull;</div>
            <a
                onClick={() => onLinkClick(post.url, index)}
                css={styles.link}
                href={addUtmSourceToUrl(post.url)}
                target="_top"
            >
                {post.title}
            </a>
        </div>
    )
}
